// Disabling sort rules for this file because it makes more sense to go in order
// of size, rather than alphabetical.
/* eslint-disable @typescript-eslint/sort-type-union-intersection-members */
/* eslint-disable sort-keys */

import { media, MEDIA_TYPES, MediaType } from "../media";

const SPACING_SIZES = ["zero", "xs", "s", "m", "l", "xl"] as const;
type SpacingSize = (typeof SPACING_SIZES)[number];

type SpacingValues = Record<SpacingSize, string>;

export const spacing: Record<MediaType, SpacingValues> = {
  mobile: {
    zero: "0",
    xs: "0.25rem",
    s: "0.5rem",
    m: "1rem",
    l: "2rem",
    xl: "4rem",
  },
  tablet: {
    zero: "0",
    xs: "0.25rem",
    s: "0.5rem",
    m: "1rem",
    l: "2rem",
    xl: "4rem",
  },
  desktop: {
    zero: "0",
    xs: "0.25rem",
    s: "0.5rem",
    m: "1rem",
    l: "2rem",
    xl: "4rem",
  },
};

// Can't use styled-components css strings because they don't like when the
// styleRule name is inserted through interpolation
function getSpacingStyles(styleRule: string): Record<SpacingSize, string> {
  return SPACING_SIZES.reduce(
    (result, size) => {
      result[size] = MEDIA_TYPES.reduce((styles, mediaType) => {
        styles += `
        @media ${media[mediaType]} {
          ${styleRule}: ${spacing[mediaType][size]};
        }
      `;
        return styles;
      }, ``);
      return result;
    },
    {} as Record<SpacingSize, string>,
  );
}

export const gap = getSpacingStyles("gap");

export const margin = getSpacingStyles("margin");
export const marginLeft = getSpacingStyles("margin-left");
export const marginTop = getSpacingStyles("margin-top");
export const marginRight = getSpacingStyles("margin-right");
export const marginBottom = getSpacingStyles("margin-bottom");
export const marginX = SPACING_SIZES.reduce(
  (result, size) => {
    result[size] = marginLeft[size] + marginRight[size];
    return result;
  },
  {} as Record<SpacingSize, string>,
);
export const marginY = SPACING_SIZES.reduce(
  (result, size) => {
    result[size] = marginTop[size] + marginBottom[size];
    return result;
  },
  {} as Record<SpacingSize, string>,
);

export const padding = getSpacingStyles("padding");
export const paddingLeft = getSpacingStyles("padding-left");
export const paddingTop = getSpacingStyles("padding-top");
export const paddingRight = getSpacingStyles("padding-right");
export const paddingBottom = getSpacingStyles("padding-bottom");
export const paddingX = SPACING_SIZES.reduce(
  (result, size) => {
    result[size] = paddingLeft[size] + paddingRight[size];
    return result;
  },
  {} as Record<SpacingSize, string>,
);
export const paddingY = SPACING_SIZES.reduce(
  (result, size) => {
    result[size] = paddingTop[size] + paddingBottom[size];
    return result;
  },
  {} as Record<SpacingSize, string>,
);
